<div class="modal-header text-center">
  <h4 class="modal-title f-w w-100">PassKey Protection</h4>
  <button
    type="button"
    class="btn-close close pull-right"
    aria-label="Close"
    (click)="onHideModal('captchaModal')"
  >
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>

<div class="modal-body p-20">
  <h2>Please Enter PassKey to Proceed</h2>
  <div class="input-container mt-2">
    <input
      type="text"
      placeholder="Enter the Pass Key"
      class="form-control captcha-input"
      [(ngModel)]="passKey"
      (keyup.enter)="handleAction('primary')"
      #passKeyInput
    />
    <p class="mt-2">
      {{this.passCode}}
    </p>
  </div>
  <div class="d-flex footer-btns mt-4 justify-content-center">
    <button
      class="btn btn-outline-secondary"
      (click)="handleAction('secondary')"
    >
      GO BACK
    </button>
    <button
      class="btn btn-primary"
      (click)="handleAction('primary')"
      [disabled]="passKey == ''"
    >
      CONTINUE
    </button>
  </div>
</div>
